import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow dark:bg-primary/12 dark:text-primary dark:shadow-none",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow dark:bg-destructive/12 dark:text-destructive dark:shadow-none",
        outline: "text-foreground",
        success:
          "border-transparent bg-success text-success-foreground shadow dark:bg-success/12 dark:text-success dark:shadow-none",
        warning:
          "border-transparent bg-warning text-warning-foreground shadow dark:bg-warning/12 dark:text-warning dark:shadow-none",
        info: "border-transparent bg-info text-info-foreground shadow dark:bg-info/12 dark:text-info dark:shadow-none",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  ...props
}: React.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return (
    <span data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
